
        var result = require("!!../../../node_modules/string-replace-loader/index.js??ruleSet[1].rules[0].use[1]!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].use[2]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[0].use[4]!./avatar.scss");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    